import { patientDisplayModel } from '@/features/enterprise/helpers';
import React from 'react';
import { DocumentPanelPrimary } from '../../components/DocumentPanel';
import InfoList from '../../components/InfoList';

const DocumentPanelPaciente: React.FC<{ encounter: fhir4.Encounter }> = ({
  encounter,
}) => {
  const patientInfo = React.useMemo(() => {
    const patientData = patientDisplayModel(encounter);

    const info: { name: string; value: string }[] = [
      {
        name: 'Nome',
        value: patientData.officialName || patientData.usualName,
      },
    ];

    if (patientData.gender) {
      info.push({ name: 'Sexo', value: patientData.gender });
    }

    if (patientData.age) {
      info.push({ name: 'Data de nascimento', value: patientData.birthDate });
      info.push({ name: 'Idade', value: patientData.age });
    }

    return info;
  }, [encounter]);

  return (
    <DocumentPanelPrimary
      title="Dados do paciente"
      content={<InfoList infos={patientInfo} />}
    />
  );
};

export default DocumentPanelPaciente;
